"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function Footer(props) {
    return react_1.default.createElement("div", { className: 'natureBackground p-4' },
        react_1.default.createElement("div", { className: 'col-3 text-center' },
            react_1.default.createElement("img", { className: 'w-50 rounded', src: '/images/wisdom of reception.jpg' }),
            react_1.default.createElement("div", { className: 'text-white' }, "\u062D\u0643\u0645\u0629 \u0627\u0644\u0625\u0633\u062A\u0642\u0628\u0627\u0644")));
}
exports.default = Footer;
